module.exports = __webpack_public_path__ + "media/images/image_strength_home-836cf01bd1592bf9afdbdecb6476d17e.jpg";